import { setup, block } from 'bem-cn';

const volmaBlock = setup({
    el: '__',
    mod: '--',
    modValue: '-'
});

export {volmaBlock}